import { render } from "./SpecialityCard.vue?vue&type=template&id=595c9a3b&scoped=true"
import script from "./SpecialityCard.vue?vue&type=script&lang=js"
export * from "./SpecialityCard.vue?vue&type=script&lang=js"

import "./SpecialityCard.vue?vue&type=style&index=0&id=595c9a3b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595c9a3b"]])

export default __exports__